import React, { ReactElement } from 'react';
import { Link } from 'react-router-dom';

import { formatUsername } from '../../../../../utils/util';

import { Member } from '../../../../../types/entity.types';

import ProfilePicture from '../../../../common/profile-picture/ProfilePicture';

import './tribe-members.scss';

type Props = {
  members: Member[];
};

const TribeMembers = ({ members }: Props): ReactElement => (
  <div className="tribe-members" data-testid="tribe-members">
    <p className="tribe-members__header">Members</p>
    {members.map((member: Member, index: number): ReactElement => {
      if (index > 4 || !member.username) {
        return <React.Fragment key={index} />;
      }

      return (
        <div className="tribe-members__member" key={index}>
          <ProfilePicture src={member.profilePicture} alt={`${member.username} - profile`} small />
          <p className="tribe-members__member__name">{formatUsername(member.username)}</p>
          {member.admin && <span className="tribe-members__member__admin-block">Admin</span>}
        </div>
      );
    })}
    <Link to="member-engagement">View All members</Link>
  </div>
);

export default TribeMembers;
